const servicesMapping = {
    homescreen: "homescreen",
    fpc: "fpc",
    fpm: "fpm",
    "transparency-dashboard-frontend": "transparency-dashboard-frontend",
    "network-purchaser": "network-purchaser",
    "network-supplier": "network-supplier",
    reductions: "reduction-homepage-frontend",
    cfc: "cfc",
};
const serviceIdsThatAreAlwaysEnabled = ["homescreen", "reductions"];
const getTokenServiceIds = (organizationAccess) => {
    const tokenServiceIds = Object.values(organizationAccess)
        .flatMap(({ services }) => {
        return services;
    })
        .concat(serviceIdsThatAreAlwaysEnabled);
    // This is based on https://climatepartner.atlassian.net/browse/RED-551.
    // Prospective customers are not supposed to have access to reductions. The
    // closest we can get to this, given just the information contained in the
    // token, is checking for `network-supplier`.
    if (tokenServiceIds.includes("network-supplier")) {
        return tokenServiceIds.filter((tokenServiceId) => tokenServiceId !== "reductions");
    }
    return tokenServiceIds;
};
export const getEnabledCpServices = (cpServices, organizationAccess) => {
    const tokenServiceIds = getTokenServiceIds(organizationAccess);
    return tokenServiceIds.reduce((acc, tokenServiceId) => {
        const cpServiceId = servicesMapping[tokenServiceId];
        const serviceUrl = cpServices?.[cpServiceId];
        if (!serviceUrl) {
            return acc;
        }
        return { ...acc, [cpServiceId]: serviceUrl };
    }, {});
};
//# sourceMappingURL=getEnabledCpServices.js.map